import { render, staticRenderFns } from "./AdviseSeats.vue?vue&type=template&id=42580f4c&"
import script from "./AdviseSeats.vue?vue&type=script&lang=js&"
export * from "./AdviseSeats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports